import translation from '@elements/translation';
import stepperStatus from './stepperEnum';

export default {
  mixins: [ translation ],
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    actualStep: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    stepperType: {
      type: String,
      default: '',
    },
    iconInfo: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getStepColor(step) {
      if (step < this.actualStep) {
        return stepperStatus.DONE;
      }
      if (step === this.actualStep) {
        return stepperStatus.IN_PROGRESS;
      }
      return stepperStatus.FUTURE;
    },
    isLastStep(step) {
      return step === this.steps.length - 1;
    },
    getColor(step) {
      return step < this.actualStep ? 'green' : 'grey';
    },
    isDisabledText(step) {
      return !(step <= this.actualStep);
    },
  },
};
